import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  initialize() {
    this.closeFromOverlay = this.closeFromOverlay.bind(this)
  }

  connect() {
    this.modalElement = this.element.matches(".modal")
      ? this.element
      : this.element.querySelector(":scope > .modal")
    this.modalElement.addEventListener("click", this.closeFromOverlay)
  }

  disconnect() {
    this.modalElement.removeEventListener("click", this.closeFromOverlay)
  }

  open() {
    this.modalElement.classList.add("is-active")
  }

  close() {
    this.modalElement.classList.remove("is-active")
  }

  closeFromOverlay(event) {
    if (event.target === this.modalElement) {
      this.close()
    }
  }
}
